/**
 * Off-canvas resize/transform helpers (Konva Transformer + live attrs).
 * Kept separate from drag-end transfer logic in dragEndUtils.js.
 */
import { constrainOffCanvasPosition } from "./dragEndUtils";

const TRANSFORMER_ANCHOR_BUFFER_PX = 10;

/**
 * Apply the same off-canvas main-column + stage rules as drag uses, for live transform attrs
 * from element components (renderers / CircleElement / RectangleElement).
 */
export const constrainOffCanvasLiveTransformAttrs = (
  baseElement,
  incomingAttrs,
  elementType,
  offCanvasStage,
) => {
  if (!offCanvasStage || !incomingAttrs) return incomingAttrs;
  const sw =
    typeof offCanvasStage.width === "function"
      ? offCanvasStage.width()
      : 0;
  if (!sw) return incomingAttrs;
  const t =
    elementType === "Rectangle" || elementType === "rectangle"
      ? "Rect"
      : elementType;
  if (t !== "Rect" && t !== "Circle" && t !== "Text") return incomingAttrs;
  if (t === "Rect") {
    // RectangleElement.onTransformEnd already performs rotation-aware off-canvas
    // clamping using rendered client-rect. Re-applying generic bbox-based
    // constrainOffCanvasPosition here can snap rotated rectangles back to stale X.
    const normalizedRotation = ((Number(incomingAttrs.rotation) || 0) % 360 + 360) % 360;
    const isAxisAligned =
      Math.abs(normalizedRotation - 0) < 0.01 ||
      Math.abs(normalizedRotation - 90) < 0.01 ||
      Math.abs(normalizedRotation - 180) < 0.01 ||
      Math.abs(normalizedRotation - 270) < 0.01;
    if (!isAxisAligned) {
      return incomingAttrs;
    }
  }
  const merged = { ...baseElement, ...incomingAttrs };
  const { constrainedX, constrainedY } = constrainOffCanvasPosition(
    merged,
    t,
    incomingAttrs.x,
    incomingAttrs.y,
    offCanvasStage,
    null,
    TRANSFORMER_ANCHOR_BUFFER_PX,
  );
  return { ...incomingAttrs, x: constrainedX, y: constrainedY };
};
